import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

function withCommunityParams(params = {}) {
  const currentCommunityId = getCommunityId()
  const requestParams = { ...params }
  if (!requestParams.communityId && !requestParams.communityIds && currentCommunityId && currentCommunityId !== '-1') {
    requestParams.communityId = currentCommunityId
  }
  return requestParams
}

function withCommunityData(data = {}) {
  const currentCommunityId = getCommunityId()
  return {
    ...data,
    communityId: data.communityId || currentCommunityId
  }
}

// 查询合同甲方列表
export function queryContractPartya(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contractPartya/queryContractPartya',
      method: 'get',
      params: withCommunityParams(params)
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加合同甲方
export function saveContractPartya(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contractPartya/saveContractPartya',
      method: 'post',
      data: withCommunityData(data)
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改合同甲方
export function updateContractPartya(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contractPartya/updateContractPartya',
      method: 'post',
      data: withCommunityData(data)
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除合同甲方
export function deleteContractPartya(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/contractPartya/deleteContractPartya',
      method: 'post',
      data: withCommunityData(data)
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
